import { render, staticRenderFns } from "./create_order.vue?vue&type=template&id=a14d6cb6&"
import script from "./create_order.vue?vue&type=script&lang=js&"
export * from "./create_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports